// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import RtlLayout from './components/RtlLayout';
import ScrollToTop from './components/ScrollToTop';
import { ProgressBarStyle } from './components/ProgressBar';
import NotistackProvider from './components/NotistackProvider';
import ThemeColorPresets from './components/ThemeColorPresets';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import ImpersonationBanner, { BANNER_HEIGHT } from './components/ImpersonationBanner';
import useAuth from './hooks/useAuth';
import { useEffect } from 'react';

// ----------------------------------------------------------------------

export default function App() {
  const { isImpersonating } = useAuth();

  useEffect(() => {
    if (process.env.REACT_APP_ENV === 'prod') {
      // Initialize GTM dataLayer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

      // Inject GTM script
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-K8JRFTJ';
      document.head.appendChild(script);

      // Inject GTM noscript iframe
      const noscript = document.createElement('noscript');
      const iframe = document.createElement('iframe');
      iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-K8JRFTJ';
      iframe.height = '0';
      iframe.width = '0';
      iframe.style.display = 'none';
      iframe.style.visibility = 'hidden';
      noscript.appendChild(iframe);
      document.body.insertBefore(noscript, document.body.firstChild);

      return () => {
        document.head.removeChild(script);
        document.body.removeChild(noscript);
      };
    }
  }, []);

  return (
    <ThemeProvider>
      <ThemeColorPresets>
        <RtlLayout>
          <NotistackProvider>
            <MotionLazyContainer>
              <ImpersonationBanner />
              {isImpersonating && (
                <style>{`
                  body { padding-top: ${BANNER_HEIGHT}px; }
                  .MuiAppBar-root { top: ${BANNER_HEIGHT}px !important; }
                `}</style>
              )}
              <ProgressBarStyle />
              <ScrollToTop />
              <Router />
            </MotionLazyContainer>
          </NotistackProvider>
        </RtlLayout>
      </ThemeColorPresets>
    </ThemeProvider>
  );
}
